import CustomError from '@/pages/_error';
import { getErrorInfo } from '@/utils/ApiError';

export function ErrorScreen({ error }: { error: unknown }) {
  const errorInfo = getErrorInfo(error);

  if (errorInfo.errorType === 'apiError') {
    return <CustomError statusCode={errorInfo.statusCode} />;
  }

  return <CustomError />;
}
